const DISMISS_STORAGE_KEY = "aivoryems.maintenance.dismissed";

export function readDismissedMaintenanceIds() {
  try {
    const raw = localStorage.getItem(DISMISS_STORAGE_KEY);
    const parsed = JSON.parse(raw || "[]");
    return new Set(Array.isArray(parsed) ? parsed.map(String) : []);
  } catch {
    return new Set();
  }
}

export function dismissMaintenanceNotice(noticeId) {
  const id = String(noticeId || "").trim();
  if (!id) return;
  const next = readDismissedMaintenanceIds();
  next.add(id);
  localStorage.setItem(DISMISS_STORAGE_KEY, JSON.stringify([...next]));
}

export function filterVisibleMaintenanceBanners(banners, dismissedIds) {
  if (!Array.isArray(banners) || !banners.length) return [];
  const dismissed = dismissedIds instanceof Set ? dismissedIds : readDismissedMaintenanceIds();
  return banners.filter((notice) => notice?.id && !dismissed.has(String(notice.id)));
}
